var exports = {
  "p_": "TimelineList.module__list___OTZfTG",
  "AS": "TimelineList.module__item___OTZfTG",
  "Qq": "TimelineList.module__text___OTZfTG",
  "j9": "TimelineList.module__clamped___OTZfTG",
};

module.exports = exports;
